import {
    COUNTRY_DOCUMENT_TYPE_DNI,
    COUNTRY_DOCUMENT_TYPE_NIE,
    COUNTRY_DOCUMENT_TYPE_DNI_LABEL,
    COUNTRY_DOCUMENT_TYPE_NIE_LABEL,
} from 'constants/multiLanguage';

const StringHelper = {
    toCamelCase(str) {
        if (str)
            return str.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
    },

    toFirstUppercase(str) {
        return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
    },

    concatString(arrayStr, char) {
        let str = '';
        const top = arrayStr.length - 1;
        arrayStr.forEach(function (element, i) {
            if (element !== '' && element !== undefined) {
                if (i < top) {
                    str += element + char;
                } else {
                    str += element;
                }
            }
        }, this);

        return str;
    },

    addSeparatorToIban(iban, separator = '-') {
        let ibanWithDashes = '';
        const top = iban.length;
        let i;
        for (i = 1; i <= top; i++) {
            ibanWithDashes += iban[i - 1];

            if (i % 4 == 0 && i !== top) {
                ibanWithDashes += separator;
            }
        }
        return ibanWithDashes;
    },

    stringReplaceAll(str, find, replace) {
        return str.replace(new RegExp(find, 'g'), replace);
    },

    capitalize(str) {
        const subStrings = str?.split(' ');
        const newSubString = [];

        subStrings?.forEach(function (item) {
            if (item.length > 1) {
                newSubString.push(item.charAt(0).toUpperCase() + item.substr(1).toLowerCase());
            } else {
                newSubString.push(item.toLowerCase());
            }
        });
        return newSubString?.join(' ');
    },

    getParameterByName(name, url = '') {
        if (url === '') {
            url = window.location.href;
        }
        name = name.replace(/[[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) {
            return null;
        }
        if (!results[2]) {
            return '';
        }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    getFirstNChars(str = '', qtty) {
        if (str.length <= qtty) return str;

        const newStr = str.substring(0, qtty);

        return `${newStr}...`;
    },

    getTextWidth(text, font, canvasElement) {
        const canvas = canvasElement || document.createElement('canvas');
        const context = canvas.getContext('2d');
        let width;

        context.font = font;

        width = Math.floor(context.measureText(text).width);

        // Width may be 0, in that case we don't want to add 1 px.
        return width ? width + 1 : width;
    },

    cutStringOverflow(str, length, ending = '...') {
        if (str.length > length) {
            return str.substring(0, length - ending.length) + ending;
        }
        return str;
    },

    changeDocType(documentType) {
        documentType = documentType.replace(':', '');
        switch (documentType) {
            case COUNTRY_DOCUMENT_TYPE_NIE:
                return COUNTRY_DOCUMENT_TYPE_NIE_LABEL;
            case COUNTRY_DOCUMENT_TYPE_DNI:
                return COUNTRY_DOCUMENT_TYPE_DNI_LABEL;
            default:
                return documentType;
        }
    },

    hasWhiteSpace(s) {
        return /\s/g.test(s);
    },

    getDigitsOnly(value) {
        return value?.replace(/\D/g, '');
    },

    hasCharacterRepeatedMoreThanTwice(value) {
        return /(\S)(\1{2,})/g.test(value);
    },
};

export default StringHelper;
